import { render, staticRenderFns } from "./ConfirmForgotPasswordDialog.vue?vue&type=template&id=5b148d8e"
import script from "./ConfirmForgotPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmForgotPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b148d8e')) {
      api.createRecord('5b148d8e', component.options)
    } else {
      api.reload('5b148d8e', component.options)
    }
    module.hot.accept("./ConfirmForgotPasswordDialog.vue?vue&type=template&id=5b148d8e", function () {
      api.rerender('5b148d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ConfirmForgotPasswordDialog.vue"
export default component.exports